<template>
<el-card class="box-card" shadow="hover">
  <div slot="header" class="clearfix" style="position:relative">
    <el-breadcrumb>
      <el-breadcrumb-item :to="{ path: 'demandlist' }">需求管理</el-breadcrumb-item>
      <el-breadcrumb-item>需求详情</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="text item">
    <el-steps v-if="(form.status==1&&form.examine==3)||form.status==3" :space="200" :active="form.status" align-center>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0" title="待审核" :description="form.createTime"></el-step>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0" title="不通过" :description="form.examineTime"></el-step>
    </el-steps>
    <!-- <el-steps v-else-if="form.status==3" :space="200" :active="form.status" align-center>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0" title="待审核" :description="form.createTime"></el-step>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0" title="子公司审核" :description="form.examineTime"></el-step>
      <el-step title="采购员审核不通过" :description="form.orderTime"></el-step>
    </el-steps> -->
    <el-steps v-else-if="form.status==5&&form.examine==3" :space="200" :active="form.status" align-center>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0||showBtn==3" title="待审核" :description="form.createTime"></el-step>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0||showBtn==3" title="子公司审核" :description="form.examineTime"></el-step>
      <el-step title="采购员审核" :description="form.orderTime"></el-step>
      <el-step title="平台负责人审核不通过" :description="form.sureTime"></el-step>
    </el-steps>
    <el-steps v-else-if="form.ispart==1" :space="200" :active="form.status" align-center>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0||showBtn==3" title="待审核" :description="form.createTime"></el-step>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0||showBtn==3" title="子公司审核" :description="form.examineTime"></el-step>
      <el-step title="采购员审核" :description="form.orderTime"></el-step>
      <el-step title="已下部分订单" :description="form.sureTime"></el-step>
      <el-step title="已下订单" :description="form.sureAllTime"></el-step>
    </el-steps>
    <el-steps v-else :space="200" :active="form.status" align-center>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0||showBtn==3" title="待审核" :description="form.createTime"></el-step>
      <el-step v-show="showBtn==1||showBtn==4||showBtn==0||showBtn==3" title="子公司审核" :description="form.examineTime"></el-step>
      <el-step title="采购员审核" :description="form.orderTime"></el-step>
      <el-step title="已下订单" :description="form.sureTime"></el-step>
    </el-steps>
    <el-form ref="form" :model="form" label-width="160px">
      <el-descriptions class="margin-top" title="需求详情" :column="3" size="medium" border style="margin-top:30px;">
        <template slot="extra">
          <el-button v-show="form.status==1&&showBtn==4" size="mini" type="info" plain @click="examineDemand(form.id,2)">审核通过</el-button>
          <el-button v-show="form.status==1&&showBtn==4" size="mini" type="warning" plain @click="examineDemand(form.id,3)">审核不通过</el-button>
          <el-button v-show="form.status==2&&showBtn==3" size="mini" type="warning" plain @click="showAddOrder(form.id)">审核</el-button>
          <el-button v-show="form.status==5&&showBtn==3" size="mini" type="warning" plain @click="showAddOrder(form.id)">继续审核</el-button>
          <el-button v-show="(form.status==4||form.status==5)&&form.count&&showBtn==0" size="mini" type="warning" plain @click="sureOrder(form.id,1)">下单</el-button>
          <el-button v-show="(form.status==4||form.status==5)&&form.count&&showBtn==0" size="mini" type="warning" plain @click="sureOrder(form.id,2)">拒绝下单</el-button>
          <el-button v-show="(form.status==4||form.status==5)&&(showBtn==0||showBtn==3)&&!form.count&&form.num!=form.costNum" size="mini" type="warning" plain @click="showFinishDemand(form.id)">结束</el-button>
          <el-button v-show="(form.status==4||form.status==5)&&(showBtn==0||showBtn==3)" size="mini" type="warning" plain @click="changeDemand(form.id)">保存</el-button>
          <el-popconfirm
            confirm-button-text='好的'
            cancel-button-text='不用了'
            icon="el-icon-info"
            icon-color="red"
            @confirm="delDemand(form.id)" 
            title="确定删除需求吗？"
          >
            <el-button v-if="form.status==1&&showBtn==1" size="mini" type="danger" plain slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
        <el-descriptions-item>
          <template slot="label">
            物料编号
          </template>
          {{form.gcode}}
        </el-descriptions-item>
        <el-descriptions-item v-if="form.cgcode">
          <template slot="label">
            客户物料编号
          </template>
          {{form.cgcode}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            物料名称
          </template>
          {{form.title}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            总价
          </template>
          <el-row v-if="(showBtn<1&&form.status!=6)">
            <el-input-number :precision="4" v-model="form.total" :min="0.00" :max="999999999"></el-input-number>
          </el-row>
          <el-row v-else>￥ {{form.total}}</el-row>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            单价
          </template>
          <el-row v-if="(showBtn<1&&form.status!=6)">
            <el-input-number :precision="4" v-model="form.price" :min="0.00" :max="999999999"></el-input-number>
          </el-row>
          <el-row v-else>￥ {{form.price}}</el-row>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            数量
          </template>
          <el-row v-if="(showBtn<1&&form.status!=6)">
            <el-input-number @change="getTotal()" v-model="form.num" :precision="2" :min="0.00" :max="999999999"></el-input-number>
          </el-row>
          <el-row v-else>{{form.num}}</el-row>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            下单数量
          </template>
          <el-row v-if="(showBtn<1&&form.status!=6)">
            <el-input-number v-model="form.costNum" :min="0.00" :max="999999999"></el-input-number>
          </el-row>
          <el-row v-else>{{form.costNum}}</el-row>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            单位
          </template>
          {{form.unit}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            要求到货时间
          </template>
          {{form.deliveryTime}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            物料描述/规格	
          </template>
          {{form.remark}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            工厂	
          </template>
          {{form.factory}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            采购员	
          </template>
          {{form.purchase}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            库位	
          </template>
          {{form.locator}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            公司	
          </template>
          {{form.company}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            采购员	
          </template>
          {{form.buyer}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            备注	
          </template>
          {{form.orderRemark}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            审核状态	
          </template>
          <p v-show="form.status==1">待审核</p>
          <p v-show="form.status==2">已通过</p>
          <p v-show="form.status==3">未通过</p>
          <p v-show="form.status==4">等待确认下单</p>
          <p v-show="form.status==5">成功下单</p>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions v-for="(v, k) in scaleArr" :key="k" class="margin-top" title="供应商详情" :column="3" size="medium" border style="margin-top:30px;">
        <el-descriptions-item>
          <template slot="label">
            供应商名称
          </template>
          {{v.company}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            物料编号
          </template>
          {{v.gcode}}
        </el-descriptions-item>
        <el-descriptions-item v-if="form.cgcode">
          <template slot="label">
            客户物料编号
          </template>
          {{v.cgcode}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            物料名称
          </template>
          {{v.title}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            总价
          </template>
          ￥ {{parseInt(v.price*v.num)}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            单价
          </template>
          <el-row v-if="(showBtn<1||showBtn==3)&&v.status<1">
            <el-input-number :precision="4" v-model="v.price" :min="0.00" :max="99999"></el-input-number>
          </el-row>
          <el-row v-else>￥ {{v.price}}</el-row>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            单位
          </template>
          {{v.unit}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            数量
          </template>
          <el-row v-if="(showBtn<1||showBtn==3)&&v.status<1">
            <el-input-number v-model="v.num" :min="0" :precision="2" :max="form.num"></el-input-number>
          </el-row>
          <el-row v-else>{{v.num}}</el-row>
        </el-descriptions-item>
        <!-- <el-descriptions-item>
          <template slot="label">
            比例
          </template>
          <el-input-number v-show="(showBtn<1||showBtn==3)&&v.status<1" v-model="v.scale" :min="0" :max="100"></el-input-number>
          <el-row v-show="!((showBtn<1||showBtn==3)&&v.status<1)">{{v.scale}}%</el-row>
        </el-descriptions-item> -->
        <el-descriptions-item>
          <template slot="label">
            状态	
          </template>
          <p v-if="v.status==1">已下单</p>
          <p v-else-if="v.status==2">审核不通过</p>
          <p v-else>待审核</p>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            物料描述/规格
          </template>
          {{v.remark}}
        </el-descriptions-item>
      </el-descriptions>
    </el-form>
  </div>
  <el-dialog title="需求下单" label-position="left" :visible.sync="orderBox" width="70%">
    <el-form ref="form" :model="orderForm" label-width="140px">
      <el-form-item label="审核状态">
        <el-radio-group v-model="orderForm.examine">
          <el-radio :label="1">审核通过</el-radio>
          <el-radio :label="2">审核不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="需求数量">
        {{this.orderForm.num}}
      </el-form-item>
      <el-form-item label="已下单数量">
        {{this.orderForm.costNum}}
      </el-form-item>
      <el-row v-show="orderForm.examine==1">
        <el-form-item v-for="(v,k) in supplier" :key="k" :label="v.name" :required="true">
          <span>数量：</span><el-input-number v-model="v.num" :min="0"></el-input-number>
          <span>价格：</span><el-input-number v-model="v.price" :min="0" :precision="4"></el-input-number>
        </el-form-item>
      </el-row>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="orderForm.orderRemark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="orderBox = false">取 消</el-button>
      <el-button type="primary" @click="makeOrder">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title="结束需求" label-position="left" :visible.sync="finishDemandBox" width="70%">
    <el-form ref="form" :model="finishDemandForm" label-width="140px">
      <el-form-item label="备注">
        <el-input type="textarea" v-model="finishDemandForm.remark" maxlength="250" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="examineDemandBox = false">取 消</el-button>
      <el-button type="primary" @click="finishDemand()">确 定</el-button>
    </div>
  </el-dialog>
</el-card>
</template>
<script>
import orderFunction from "@/api/order"
import userFunction from "@/api/user"
export default {
  data() {
    return {
      showBtn:sessionStorage.getItem('roleid'),
      sendBox:false,
      orderBox:false,
      finishDemandBox:false,
      supplier:[],
      scaleArr:[],
      sendForm:{
        id:'',
        sendType:0,
        expressCompany:'',
        expressNum:0,
        expressSn:'',
        expressRemark:'',
        vcode:sessionStorage.getItem('token'),
      },
      orderForm:{
        id:'',
        scale:'',
        examine:1,
        num:0,
        costNum:0,
        scaleData:[],
        orderRemark:'',
        vcode:sessionStorage.getItem('token')
      },
      finishDemandForm:{
        id:'',
        remark:'',
        vcode:sessionStorage.getItem('token')
      },
      form:{
        id:'',
        company:'',
        buyer:'',
        gcode:'',
        cgcode:'',
        title:'',
        total:'',
        price:'',
        unit:'',
        num:'',
        costNum:'',
        remark:'',
        deliveryTime:'',
        factory:'',
        purchase:'',
        locator:'',
        sellerid:'',
        examine:0,
        examineMsg:'',
        sendType:'',
        ispart:0,
        send_start_time:'',
        send_end_time:'',
        receiveTime:'',
        finishTime:'',
        orderRemark:'',
        createTime:'',
        examineTime:'',
        orderTime:'',
        sureTime:'',
        sureAllTime:'',
        uname:'',
        status:1,
        goods:[],
        log:[],
        count:0,
        vcode:sessionStorage.getItem('token'),
      },
    };
  },
  methods:{
    getTotal(){
      var total = this.form.num * this.form.price
      this.form.total = total.toFixed(2)
    },
    getOrder(){
      orderFunction.getdemand(this.form,this).then(res=>{
        this.form.id = res.id
        this.form.company = res.company
        this.form.buyer = res.buyer
        this.form.gcode = res.gcode
        this.form.cgcode = res.cgcode
        this.form.title = res.title
        this.form.total = res.total
        this.form.price = res.price
        this.form.unit = res.unit
        this.form.num = res.num
        this.form.costNum = res.costNum
        this.form.remark = res.remark
        this.form.deliveryTime = res.deliveryTime
        this.form.factory = res.factory
        this.form.purchase = res.purchase
        this.form.locator = res.locator
        this.form.sellerid = res.sellerid
        this.form.ispart = res.ispart
        this.form.examine = res.examine
        this.form.examineMsg = res.examineMsg
        this.form.sendType = res.sendType
        this.form.orderRemark = res.orderRemark
        this.form.createTime = res.createTime
        this.form.examineTime = res.examineTime
        this.form.orderTime = res.orderTime
        this.form.examineTime = res.examineTime
        this.form.sureTime = res.sureTime
        this.form.sureAllTime = res.sureAllTime
        this.form.uname = res.uname
        this.form.status = res.status
        this.form.goods = res.goods
        this.form.count = res.count
        this.scaleArr = res.scaleArr
      })
    },
    examineDemand(id,n){
      orderFunction.examineDemand({id:id,n:n,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getOrder()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showAddOrder(id){
      this.orderBox = true
      this.orderForm.scaleData = []
      this.orderForm.examine = 1
      this.orderForm.orderRemark = ''
      this.orderForm.id = id
      this.getdemand()
      this.getSupplier()
    },
    getSupplier(){
      userFunction.getSupplier({demandid:this.orderForm.id,vcode:sessionStorage.getItem('token')},this).then((res) => {
        this.supplier = res
        for(var i in this.supplier){
          this.supplier[i].num = parseFloat((this.orderForm.num-this.orderForm.costNum)*this.supplier[i].scale/100)
        }
      })
    },
    makeOrder(){
      this.orderForm.scaleData = []
      var supplier = this.supplier
      for(var i in supplier){
        this.orderForm.scaleData.push({id:supplier[i].id,gid:supplier[i].gid,companyid:supplier[i].companyid,price:supplier[i].price,scale:supplier[i].scale,num:supplier[i].num})
      }
      orderFunction.makeOrder(this.orderForm,this).then(res=>{
        this.getOrder()
        this.orderBox = false
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    getdemand(){
      orderFunction.getdemand({id:this.orderForm.id,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.orderForm.scaleData = []
        this.orderForm.scale = res.goods.scale
        this.orderForm.num = res.num
        this.orderForm.costNum = res.costNum
        for(var i in res.scaleArr){
          this.orderForm.scaleData.push({scale:res.scaleArr[i],value:parseInt(parseInt(res.num)*parseInt(res.scaleArr[i]) /100)})
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    sureOrder(id,type){
      orderFunction.sureOrder({id:id,type:type,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getOrder()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    delDemand(id){
      var delData = [];
      if(id){
        delData.push(id)
      }else{
        delData = this.Selectionids
      }
      orderFunction.delDemand({id:delData,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.$router.push({path: '/home/demandlist'})
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    changeDemand(id){
      orderFunction.changeDemand({id:id,scaleData:this.scaleArr,vcode:sessionStorage.getItem('token')},this).then(res=>{
        this.getOrder()
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    showFinishDemand(id){
      this.finishDemandForm.id = id
      this.finishDemandForm.remark = ''
      this.finishDemandBox = true
    },
    finishDemand(){
      orderFunction.finishDemand(this.finishDemandForm,this).then(res=>{
        this.getOrder()
        this.finishDemandBox = false
      }).catch(err=>{
        this.$message.error(err)
      })
    },
  },
  mounted () {
    this.form.id = this.$route.query.id
    this.getOrder()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/order/editDemand.vue